import { FormattedMessage } from 'react-intl'

export const RxLpComHowBonusIsCalculatedDataBody = [
  {
    key: 'data-1',
    medication: <FormattedMessage id="rx.com.bonus.table.row.1.medication" />,
    perscriptionBonus: (
      <FormattedMessage id="rx.com.bonus.table.row.1.prescription" />
    ),
    totalBonus: <FormattedMessage id="rx.com.bonus.table.row.1.total" />,
  },
  {
    key: 'data-2',
    medication: <FormattedMessage id="rx.com.bonus.table.row.2.medication" />,
    perscriptionBonus: (
      <FormattedMessage id="rx.com.bonus.table.row.2.prescription" />
    ),
    totalBonus: <FormattedMessage id="rx.com.bonus.table.row.2.total" />,
  },
  {
    key: 'data-3',
    medication: <FormattedMessage id="rx.com.bonus.table.row.3.medication" />,
    perscriptionBonus: (
      <FormattedMessage id="rx.com.bonus.table.row.3.prescription" />
    ),
    totalBonus: <FormattedMessage id="rx.com.bonus.table.row.3.total" />,
  },
]

export const RxLpComHowBonusIsCalculatedDataHead = [
  {
    heading: <FormattedMessage id="rx.com.bonus.table.heading.1" />,
    key: 'heading-1',
  },
  {
    heading: <FormattedMessage id="rx.com.bonus.table.heading.2" />,
    key: 'heading-2',
  },
  {
    heading: <FormattedMessage id="rx.com.bonus.table.heading.3" />,
    key: 'heading-3',
  },
]
